import { AVG_WIN_LOSS_CURRENCY } from "./AVG_WIN_LOSS_CURRENCY";
import { WIN_LOSS_PERCENTAGE } from "./WIN_LOSS_PERCENTAGE";

const InsightComparisonDemoDataMap = {
  AVG_WIN_LOSS_CURRENCY: AVG_WIN_LOSS_CURRENCY,
  WIN_LOSS_PERCENTAGE: WIN_LOSS_PERCENTAGE,
};

export default InsightComparisonDemoDataMap;
